import { ORDER_STATUS } from './constants';

/**
 * Customer details (name, phone, address, notes) only become visible to
 * vendors after they accept an order. Matches the backend rule in
 * eventi-backend/src/services/orderStatusTransition.ts (hasBeenApproved).
 *
 * Covers both backend status values ('Approved', 'Changing', 'In-progress',
 * 'Delivery') and legacy UI labels from ORDER_STATUS.
 */
const CUSTOMER_VISIBLE_STATUSES = new Set<string>([
  'approved',
  ORDER_STATUS.CONFIRMED.toLowerCase(),
  'changing',
  ORDER_STATUS.CHANGES.toLowerCase(),
  'in-progress',
  ORDER_STATUS.IN_PROGRESS.toLowerCase(),
  'delivery',
  ORDER_STATUS.DELIVERING.toLowerCase(),
  'completed',
]);

export const CUSTOMER_DETAILS_PLACEHOLDER = 'Hidden until accepted';

export const canViewCustomerDetails = (status?: string): boolean =>
  !!status && CUSTOMER_VISIBLE_STATUSES.has(status.toLowerCase());
